import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Refinance',
    templateUrl: './Refinance.component.html',
    styleUrls: ['./Refinance.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RefinanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
